import { actionConstants } from './actionConstants';
import noti from './toast';
import { get, post, put, _delete } from './method';

export default {
  resetCompleted,
  getSensorDetail,
  editSensor,
  getAssignedSensors,
  getUnassignedSensors,
  assignSensors,
  replaceSensor,
  unassignSensors,
  deleteUnassignedSensors,
  repurposeSensors,
  updateActiveSensor,
  updateAlertsSensor,
  getAlarmStatus,
  getAlarmStatusV2,
  getAlarmStatusByGroup,
  getAlarmStatusByGroupV2,
  getSensorInfo,
};

function resetCompleted() {
  return (dispatch) => {
    dispatch({ type: actionConstants.RESET_COMPLETED });
  };
}

function getSensorDetail(sensorId) {
  return async (dispatch) => {
    return await get(`app/sensors/${sensorId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSOR_DETAIL_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSOR_DETAIL_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}
function editSensor(sensorId, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await put(`app/sensors/${sensorId}`, params)
      .then((resp) => {
        dispatch({
          type: actionConstants.EDIT_SENSOR_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_SENSOR_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}
function getAssignedSensors(groupId) {
  return async (dispatch) => {
    return await get(`app/sensors/assigned/${groupId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ASSIGNED_SENSORS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_ASSIGNED_SENSORS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getUnassignedSensors() {
  return async (dispatch) => {
    return await get(`app/sensors/unassigned`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_UNASSIGNED_SENSORS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_UNASSIGNED_SENSORS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function assignSensors(groupId, sensorIds) {
  return async (dispatch) => {
    let params = {
      body: sensorIds,
    };
    return await put(`app/sensors/assign-group/${groupId}`, params)
      .then((resp) => {
        dispatch({
          type: actionConstants.ASSIGN_SENSORS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.ASSIGN_SENSORS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function replaceSensor(existingSensorId, unassignedSensorId) {
  return async (dispatch) => {
    return await put(
      `app/sensors/replace/${existingSensorId}/${unassignedSensorId}`,
    )
      .then((resp) => {
        dispatch({
          type: actionConstants.REPLACE_SENSOR_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.REPLACE_SENSOR_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function unassignSensors(sensorIds) {
  return async (dispatch) => {
    let params = {
      body: sensorIds,
    };
    return await post(`app/sensors/unassign-group/`, params)
      .then((resp) => {
        dispatch({
          type: actionConstants.UNASSIGN_SENSORS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.UNASSIGN_SENSORS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function deleteUnassignedSensors(sensorIds) {
  return async (dispatch) => {
    return await _delete(
      `app/sensors/unassign?sensorIds=${sensorIds.join(',')}`,
    )
      .then((resp) => {
        dispatch({
          type: actionConstants.DELETE_ASSIGNED_SENSORS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_ASSIGNED_SENSORS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function repurposeSensors(sensorIds) {
  return async (dispatch) => {
    return await put(`app/sensors/repurpose/${sensorIds.join(',')}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.UNASSIGN_SENSORS_SUCCESS,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function updateActiveSensor(sensorId, active) {
  return async (dispatch) => {
    return await put(`app/sensors/${sensorId}/active-setting?active=${active}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.UPDATE_ACTIVE_SENSOR_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.UPDATE_ACTIVE_SENSOR_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function updateAlertsSensor(sensorId, alarms) {
  return async (dispatch) => {
    return await put(`app/sensors/${sensorId}/alarms-setting?alarms=${alarms}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.UPDATE_ALERTS_SENSOR_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.UPDATE_ALERTS_SENSOR_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getAlarmStatus(sensorIds) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(`app/sensors/alarmStatus/${sensorIds}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ALARM_STATUS_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_ALARM_STATUS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

async function getAlarmStatusV2(sensorIds) {
  return await get(`app/sensors/alarmStatus/${sensorIds}`);
}

function getAlarmStatusByGroup(groupIds) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await get(`app/sensors/alarmStatus/by-group/${groupIds}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ALARM_STATUS_BY_GROUP_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_ALARM_STATUS_BY_GROUP_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

async function getAlarmStatusByGroupV2(groupIds) {
  return await get(`app/sensors/alarmStatus/by-group/${groupIds}`);
}

function getSensorInfo(sensorIds) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/sensors/info?sensorIds=${sensorIds}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSORS_INFO_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSORS_INFO_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}
